import {languages} from 'locale';
import {evaluate} from './options';

const TRANSCRIPT_PREFIX = 'c24Trans';

const getAPI = kdp => new window.kWidget.api({ // eslint-disable-line new-cap
    ks: evaluate(kdp, 'configProxy.flashvars.ks'),
    wid: `_${evaluate(kdp, 'configProxy.kw.partnerId')}`,
});

const getAPICall = (api) => (req) => new Promise(resolve =>
    api.doRequest(req, res => resolve(res)),
);

const validLanguages = languages.map(lng => lng.value);
const parseLanguage = lng => {
    if (!lng) return;
    const legacy = {cmn: 'zh_CMN', zh: 'zh_TW'};
    const language = legacy[lng] || lng;
    if (language && validLanguages.includes(language)) return language;
};

const parseAttachmentIdentifier = identifier => {
    const [name, extension] = identifier.split('.');
    const [prefix, language] = name.split('_');
    return {prefix, extension, language: parseLanguage(language)};
};

export const loadElementListManifest = async ({kdp, entry}) => {
    const request = {service: 'attachment_attachmentAsset'};
    const callAPI = getAPICall(getAPI(kdp));

    const list = await callAPI({
        service: 'attachment_attachmentAsset',
        action: 'list',
        'filter:entryIdEqual': entry.id,
    });

    let urls = await Promise.all(
        list.objects
            .filter(({filename, title}) => {
                const {prefix, extension} = parseAttachmentIdentifier(title || filename);
                if (extension && extension !== 'json') return false;
                if (prefix !== TRANSCRIPT_PREFIX) return false;
                return true;
            })
            .map(async ({id, filename, title}) => {
                const href = await callAPI({...request, action: 'getUrl', id});
                const {language} = parseAttachmentIdentifier(title || filename);
                return {language, href};
            }),
    );
    urls = urls.filter(({language, href}) => Boolean(language) && Boolean(href));

    if (!urls.length) return;

    return urls.reduce((manifest, {language, href}) => {
        if (!language || !href) return manifest;

        manifest[language] = {language, href};
        return manifest;
    }, {});
};

const CAPTION_TYPES = {1: 'srt', 2: 'dfxp', 3: 'webvtt', 4: 'cap', 5: 'scc'};
export const loadCaptionsManifest = async ({kdp, entry}) => {
    const request = {service: 'caption_captionAsset'};

    const callAPI = getAPICall(getAPI(kdp));

    const list = await callAPI({
        ...request,
        action: 'list',
        'filter:entryIdEqual': entry.id,
    });

    const urls = await Promise.all(
        list.objects.map(async (caption) => {
            const {languageCode, format} = caption;
            const href = await callAPI({...request, action: 'getUrl', id: caption.id});
            return {href, format: CAPTION_TYPES[format], language: languageCode};
        }),
    );

    if (!urls.length) return;

    return urls.reduce((manifest, {format, language, href}) => {
        if (!format || !language || !href) return manifest;
        if (!manifest[language]) manifest[language] = [];
        manifest[language].push({format, language, href});
        return manifest;
    }, {});
};



// WEBPACK FOOTER //
// ./scripts/adapters/kaltura/element-list.js